var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionButtonDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.938,
    height: 18.679,
    viewBox: "0 0 13.938 18.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Bin",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13600",
    "data-name": "Path 13600",
    d: "M9.589.037s-6.915-.083-8.253,0S0,1.861,0,1.861V13.178",
    transform: "translate(12.012 17.675) rotate(180)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13601",
    "data-name": "Path 13601",
    d: "M9.589,13.14s-6.915.083-8.253,0S0,11.317,0,11.317V0",
    transform: "translate(0.862 4.497)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13602",
    "data-name": "Path 13602",
    d: "M-.2.01l11.163,0",
    transform: "translate(1.099 4.493)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13603",
    "data-name": "Path 13603",
    d: "M-.2.011l12.937,0",
    transform: "translate(0.2 2.413)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13604",
    "data-name": "Path 13604",
    d: "M3.464.005S.966-.006.483.005,0,.256,0,.256V1.812",
    transform: "translate(4.239 0)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13605",
    "data-name": "Path 13605",
    d: "M3.516,1.807S.98,1.818.49,1.807,0,1.556,0,1.556V0",
    transform: "translate(8.699 1.812) rotate(180)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13606",
    "data-name": "Path 13606",
    d: "M0,0,7.4,0",
    transform: "translate(6.468 7.387) rotate(90)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13607",
    "data-name": "Path 13607",
    d: "M0,0,7.4,0",
    transform: "translate(9.069 7.387) rotate(90)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13608",
    "data-name": "Path 13608",
    d: "M0,0,7.4,0",
    transform: "translate(3.868 7.387) rotate(90)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonDelete);
export default __webpack_public_path__ + "static/media/action_button_delete.04ff08ee7c6d8b3e74019ad55d39b576.svg";
export { ForwardRef as ReactComponent };